<template lang="pug">
#WtTableCellLongText(
  @mouseover="isHovered = true"
  @mouseleave="isHovered = false"
)
  span(ref="textCell" :class="{'show-full-text': showFullText }") {{ text }}
</template>

<script>
export default {
  name: "WtTableCellLongText",

  props: {
    text: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      isHovered: false
    };
  },

  computed: {
    showFullText() {
      return this.isHovered && this.isOverflow();
    }
  },

  methods: {
    isOverflow() {
      // Note: "$refs are only populated after the component has been rendered, and they are not reactive.
      //  It is only meant as an escape hatch for direct child manipulation - you should avoid accessing $refs from within templates or computed properties.
      //  https://vuejs.org/v2/guide/components-edge-cases.html#Accessing-Child-Component-Instances-amp-Child-Elements
      if (!this.$refs.textCell) return true;

      return this.$refs.textCell.clientWidth < this.$refs.textCell.scrollWidth;
    }
  }
};
</script>

<style lang="sass" scoped>
#WtTableCellLongText
  /* add  BTableColumn(cell-class="has-text-hover") for this to work */
  position: relative
  span
    /* make sure width is set */
    width: 100%
    /* Both of the following are required for text-overflow */
    position: relative
    overflow: hidden
    text-overflow: ellipsis
    display: inline-block
    &.show-full-text
      position: absolute
      top: -15%
      left: -15%
      z-index: 1 // make sure doesn't overlap with another column
      background: $light
      color: black
      border-radius: $radius-small
      padding: .5rem
      max-width: auto
      width: auto
      overflow: visible
      text-overflow: visible
  /* overflow-x: auto is applied to table at tablet breakpoint, so here we ensure the tooltip is in view */
  +tablet-only
    span
      &.show-full-text
        left: -65%
</style>
